import {Box, styled} from "@mui/material";

const StyledBox = styled(Box)(() => ({
  // paddingTop: '50%',
  flex: 1,
  display: 'flex',
  overflow: 'hidden',
  justifyContent: 'center',
  alignItems: 'center',
  // minHeight: 'calc(100vh - 70px)',
  height: '100%',
  width: '100%',
}))

const LoadingScreen = () => {
  return <StyledBox>
    <div className="dom-loader"/>
  </StyledBox>;
};

export default LoadingScreen;